module.exports = __webpack_public_path__ + "static/media/button-bg-long.b30cff7c.png";